import React, { useState } from 'react';
import { TrendingUp, Sparkles } from 'lucide-react';
import { Card, Input } from '../ui';
import { cn } from '../../lib/utils';

export function MemberRetentionEstimator() {
  const [startingMembers, setStartingMembers] = useState('150');
  const [annualRecruits, setAnnualRecruits] = useState('30');
  const [attritionRate, setAttritionRate] = useState('15');

  const start = parseInt(startingMembers) || 0;
  const recruits = parseInt(annualRecruits) || 0;
  const attr = parseFloat(attritionRate) || 0;

  const lost = Math.round(start * (attr / 100));
  const finalCount = start + recruits - lost;
  const retentionRateVal = 100 - attr;

  return (
    <div className="grid md:grid-cols-2 gap-8">
      <Card className="p-6 space-y-4 border-2 border-black dark:border-white border-gray-150">
        <h3 className="text-lg font-bold flex items-center gap-2 mb-2">
          <TrendingUp className="text-amber-500" size={20} /> Retention Modeling
        </h3>
        <div className="space-y-4">
          <div>
            <label className="text-[10px] font-bold text-gray-400 uppercase font-mono">Current Members</label>
            <Input type="number" value={startingMembers} onChange={(e) => setStartingMembers(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] font-bold text-gray-400 uppercase font-mono">Yearly Recruits</label>
              <Input type="number" value={annualRecruits} onChange={(e) => setAnnualRecruits(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-400 uppercase font-mono">Yearly Attrition %</label>
              <Input type="number" value={attritionRate} onChange={(e) => setAttritionRate(e.target.value)} />
            </div>
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-slate-50 border-2 border-black dark:border-white dark:bg-slate-900 flex flex-col justify-between">
        <div className="space-y-4">
          <span className="text-xs font-bold text-gray-400 uppercase tracking-wider font-mono">Estimated 1-Year Forecast</span>
          
          <div className="space-y-2">
            <div className="flex justify-between items-center py-2 border-b border-black dark:border-white/60 text-sm">
              <span>Active Member Retention Rate:</span>
              <span className="font-bold text-emerald-600">{retentionRateVal}%</span>
            </div>
            <div className="flex justify-between items-center py-2 border-b border-black dark:border-white/60 text-sm">
              <span>Lost Members (due to attrition):</span>
              <span className="font-bold text-red-650">{lost}</span>
            </div>
            <div className="flex justify-between items-center py-3 text-base">
              <span className="font-bold">Forecasted Year-End Roster:</span>
              <span className={cn(
                "font-bold font-mono text-lg",
                finalCount >= start ? "text-emerald-600" : "text-amber-600"
              )}>
                {finalCount} members
                <span className="text-xs font-semibold font-sans block text-right mt-0.5">
                  ({finalCount >= start ? `+${finalCount - start}` : finalCount - start} variance)
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="pt-4 text-[10px] text-gray-500 flex items-center gap-1.5 border-t border-black dark:border-white/40">
          <Sparkles className="w-4.5 h-4.5 text-amber-500" />
          <span>Increase retention levels by utilizing structured sub-orgs and communication channels.</span>
        </div>
      </Card>
    </div>
  );
}
